<template>
  <v-app >
    <router-view
      v-if="$route.meta.authName === 'NotRequired'"
      name="custom"
    />
    <AbrIndex v-else />
  </v-app>
</template>

<script>
import "@/assets/materialdesignicons.css";
import AbrIndex from "@/components/AbrIndex";
import { applyGlobalTheme } from "@/themes";

export default {
  name: "App",
  components: { AbrIndex },

  computed: {
    compId() {
      return this.$store.state.instance || "day";
    }
  },

  watch: {
    '$vuetify.theme.dark': {
      handler() { this.applyTheme(); },
      immediate: true
    },
    compId() {
      this.applyTheme();
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.$nextTick(() => this.applyTheme());
    });
  },

  methods: {
    applyTheme() {
      if (!this.$vuetify?.theme) return;
      applyGlobalTheme(this.$vuetify, this.compId);
    }
  }
};
</script>
